import axios from 'axios'
export default {
	install: Vue => {
		Vue.prototype.download = (url, postData, nombreFichero, callback) => {
			axios({
				url: url,
				method: 'POST',
				data: postData,
				responseType: 'blob',
				headers: {
					'Content-type': 'application/json',
					'Accept': 'application/x-binary'
				}
			})
				.then(res => {
					const a = document.createElement('a')
					let extension = /\./.test(nombreFichero) ? nombreFichero.split('.').splice(-1, 1)[0] : 'pdf'
					let file
					if (!extension) {
						file = new Blob([res.data], {type: 'application/pdf'})
					} else {
						file = new Blob([res.data], { type: 'application/octet-stream' })
					}
					const url = URL.createObjectURL(file)
					a.name = nombreFichero
					a.href = url
					a.download = nombreFichero
					document.body.appendChild(a)
					a.click()
					window.setTimeout(() => {
						document.body.removeChild(a)
						if (callback) {
							try {
								callback()
							} catch (e) {
								console.error(e)
							}
						}
					}, 3000)
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/libs/download.js